import http from "./HttpService";

const BASE_SERVICE_URL = "merchant-service";

export default {
  getCustomerPortalToken(request) {
    return new Promise((resolve, reject) => {
      http
        .post(BASE_SERVICE_URL + "/token/customer-portal", request)
        .then(response => {
          return resolve(response);
        })
        .catch((status, errors) => {
          reject(status, errors);
        });
    });
  },
  getMerchantSettings(request) {
    return new Promise((resolve, reject) => {
      http
        .get(BASE_SERVICE_URL + "/settings", request)
        .then((response) => {
          return resolve(response);
        })
        .catch((status, errors) => {
          reject(status, errors);
        });
    });
  },
  getMerchantMaintenance( request) {
    return new Promise((resolve, reject) => {
      http
        .post(BASE_SERVICE_URL + "/merchant/settings", { role: 'customer_web' }, request)
        .then((response) => {
          return resolve(response);
        })
        .catch((status, errors) => {
          reject(status, errors);
        });
    });
  },
  getGoogleTagCode(request) {
    return new Promise((resolve, reject) => {
      http
        .get(
          `${BASE_SERVICE_URL}/v1/customer/analytics/code/view`,
          request
        )
        .then(response => resolve(response))
        .catch((status, errors) => reject(status, errors));
    });
  }
};
